module.exports = __webpack_public_path__ + "media/theme/icon__social-4415e81a.png";